module.exports = __webpack_public_path__ + "img/calendar.441b2345.svg";